// ─────────────────────────────────────────────────────────────
// CONFIG TYPEFORM
// Reemplazá el valor de TYPEFORM_ID por el ID de tu Typeform.
// El ID es la parte final de tu enlace:
//   https://form.typeform.com/to/XXXXXXXX  →  TYPEFORM_ID = 'XXXXXXXX'
// ─────────────────────────────────────────────────────────────
export const TYPEFORM_ID = 'AYVIuMTW'

/** URL embebible del Typeform para usar dentro del popup (iframe). */
export function getTypeformEmbedUrl(): string {
  return `https://form.typeform.com/to/${TYPEFORM_ID}?typeform-embed=embed-widget&disable-auto-focus=true`
}
